
import A_1 from '@/components/A/a_1/A_1_UI'
import A1 from '@/components/A/A1/A_1_UI'
import A1tmp from '@/components/A/A1/A_1_UItmp'
import A1index from '@/components/A/A1/A_1_UI_index'
import A1a from '@/components/A/A1/A_1_UIa'
import A1b from '@/components/A/A1/A_1_UIb'
import A1c from '@/components/A/A1/A_1_UIc'
import A1d from '@/components/A/A1/A_1_UId'
import A1map from '@/components/A/A1/A_1_map'
import A2 from '@/components/A/A2/A_2_UI'
import A2tmp from '@/components/A/A2/A_2_UItmp'
import A2a from '@/components/A/A2/A_2_UIa'
import A2b from '@/components/A/A2/A_2_UIb'
import A2c from '@/components/A/A2/A_2_UIc'
import A2d from '@/components/A/A2/A_2_UId'
import A2e from '@/components/A/A2/A_2_UIe'
import A2f from '@/components/A/A2/A_2_UIf'
import A2g from '@/components/A/A2/A_2_UIg'
import A3 from '@/components/A/A3/A_3_UI'
import A_2 from '@/components/A/A_2/A_2_UI'
import A_2_Upper from '@/components/A/A_2/A_2_Upper'
// import A_3 from '@/components/A/a3/A_3_UI'
// import A_4 from '@/components/A/a4/A_4_UI'
// import A_5 from '@/components/A/a5/A_5_UI'
// import A_5_Control from '@/components/A/a5/A_5_Control'
// import A_6_UI from '@/components/A/a6/A_6_UI'
// import A_6_UI from '@/components/A/a6/A_6_UIf1'
// import A_6_UI from '@/components/A/a6/A_6_UIf1_2'
// import A_6_UI from '@/components/A/a6/A_6_UIf1_with57'
// import A_7 from '@/components/A/a7/A_7_UI'

export default [
    { path: '/A/A1', name: 'A1', component: A1},
    { path: '/A/A1tmp', name: 'A1tmp', component: A1tmp},
    { path: '/A/A1index', name: 'A1index', component: A1index},
    { path: '/A/A2', name: 'A2', component: A2},
    { path: '/A/A2tmp', name: 'A2tmp', component: A2tmp},
    { path: '/A/A3', name: 'A3', component: A3},
    { path: '/A/A1a', name: 'A1a', component: A1a},
    { path: '/A/A1b', name: 'A1b', component: A1b},
    { path: '/A/A1c', name: 'A1c', component: A1c},
    { path: '/A/A1d', name: 'A1d', component: A1d},
    { path: '/A/A1map', name: 'A1map', component: A1map},
    { path: '/A/A2a', name: 'A2a', component: A2a},
    { path: '/A/A2b', name: 'A2b', component: A2b},
    { path: '/A/A2c', name: 'A2c', component: A2c},
    { path: '/A/A2d', name: 'A2d', component: A2d},
    { path: '/A/A2e', name: 'A2e', component: A2e},
    { path: '/A/A2f', name: 'A2f', component: A2f},
    { path: '/A/A2g', name: 'A2g', component: A2g},
    { path: '/A/A_1', name: 'A_1', component: A_1},
    { path: '/A/A_2', name: 'A_2', component: A_2},
    { path: '/A/A_2_Upper', name: 'A_2_Upper', component: A_2_Upper},
    // { path: '/A/A_3', name: 'A_3', component: A_3},
    // { path: '/A/A_4', name: 'A_4', component: A_4},
    // { path: '/A/A_5', name: 'A_5', component: A_5},
    // { path: '/A/A_5_Control', name: 'A_5_Control', component: A_5_Control},
    // { path: '/A/A_6', name: 'A_6', component: A_6_UI},
    // { path: '/A/A_7', name: 'A_7', component: A_7},
]